module.exports = __webpack_public_path__ + "bny.002d5830592811b2d7dc20c529a56d71.svg";